export default __webpack_public_path__ + "static/media/black_and_white_mandala.a91e35e9.jpg";